export enum ProxyErrorTypes {
  S = 'S',
  D = 'D',
}

export interface IProxyError {
  service_name: string;
  service_id: number;
  status_code: number | null;
  error_code: number;
  type: ProxyErrorTypes | null;
  conn: string | null;
  error_description: string;
  user_ban_duration: number;
  id: number;
}

export interface IProxyErrorCreate {
  service_id: number;
  status_code: number | null;
  error_code: number;
  type: ProxyErrorTypes | null;
  conn: string | null;
  error_description: string;
  user_ban_duration: number;
}

export interface IProxyErrorUpdate {
  service_id?: number;
  status_code?: number | null;
  error_code?: number;
  type?: ProxyErrorTypes | null;
  conn?: string | null;
  error_description?: string;
  user_ban_duration?: number;
}
